import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

import { i18n } from "../../translate/i18n";
import useModernDialogStyles from "../CrudListPage/useModernDialogStyles";

const ConfirmationModal = ({ title, children, open, onClose, onConfirm }) => {
	const classes = useModernDialogStyles();

	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="confirm-dialog"
			classes={{ paper: classes.paper }}
		>
			<DialogTitle id="confirm-dialog" className={classes.title}>
				{title}
			</DialogTitle>
			<DialogContent dividers className={classes.contentDividers}>
				<Typography className={classes.bodyText}>{children}</Typography>
			</DialogContent>
			<DialogActions className={classes.actions}>
				<Button
					variant="outlined"
					onClick={() => onClose(false)}
					color="default"
					className={classes.cancelButton}
				>
					{i18n.t("confirmationModal.buttons.cancel")}
				</Button>
				<Button
					variant="contained"
					onClick={() => {
						onClose(false);
						onConfirm();
					}}
					color="secondary"
					className={classes.confirmButton}
				>
					{i18n.t("confirmationModal.buttons.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
